(function () {
  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addBundleToCart(button) {
    var variantIdsStr = button.getAttribute('data-variant-ids');
    var successMessage = button.getAttribute('data-success-message') || 'Added to cart';
    if (!variantIdsStr || !variantIdsStr.trim()) return;

    var ids = variantIdsStr.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (ids.length === 0) return;

    var items = ids.map(function (id) {
      return { id: parseInt(id, 10), quantity: 1 };
    });

    var wrapper = button.closest('.bundle__actions');
    var errorEl = wrapper ? wrapper.querySelector('.bundle__error') : null;
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    button.disabled = true;
    button.classList.add('is-loading');

    fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        button.disabled = false;
        button.classList.remove('is-loading');
        if (data.status && (data.status === 422 || data.status === 404)) {
          if (errorEl) {
            errorEl.textContent = data.description || data.message || 'Could not add items to cart.';
            errorEl.hidden = false;
          }
          return;
        }
        if (typeof window.CartDrawer !== 'undefined' && window.CartDrawer.open) {
          window.CartDrawer.open();
        }
        if (typeof document.dispatchEvent === 'function') {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(function (err) {
        button.disabled = false;
        button.classList.remove('is-loading');
        if (errorEl) {
          errorEl.textContent = 'Could not add items to cart. Please try again.';
          errorEl.hidden = false;
        }
      });
  }

  function init() {
    document.querySelectorAll('[data-bundle-add]').forEach(function (btn) {
      if (btn.dataset.bundleAddInitialized) return;
      btn.dataset.bundleAddInitialized = 'true';
      btn.addEventListener('click', function () {
        addBundleToCart(btn);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
